/**
 * Value spotlight — big number, current wardrobe value, purchase delta.
 */
import { store } from '../store.ts';
import { formatINR } from '../types.ts';

export class AlmariValueSpotlight extends HTMLElement {
  #shadow = this.attachShadow({ mode: 'open' });
  #unsub?: () => void;

  connectedCallback(): void {
    this.#unsub = store.subscribe((s) => {
      if (s.summary) this.#render(s.summary.total_current_value_inr, s.summary.total_value_inr, s.summary.total_items, s.summary.insights.avg_cost_per_wear, s.summary.insights.wardrobe_age_avg_days);
    });
  }
  disconnectedCallback(): void { this.#unsub?.(); }

  #render(current: number, purchase: number, count: number, avgCpw: number, avgAge: number): void {
    const dep = purchase > 0 ? Math.round((1 - current / purchase) * 100) : 0;
    this.#shadow.innerHTML = /* html */ `
<style>
:host {
  display: block;
  background: var(--paper-card);
  border: 1px solid var(--brass);
  border-radius: 8px;
  padding: 24px 22px 28px;
  position: relative;
  overflow: hidden;
}
.label {
  font-family: var(--mono);
  font-size: 10px;
  letter-spacing: 0.4em;
  text-transform: uppercase;
  color: var(--brass-dim);
}
.value {
  font-family: var(--display);
  font-size: clamp(48px, 14cqw, 84px);
  font-weight: 700;
  margin-top: 8px;
  line-height: 0.95;
  letter-spacing: -0.025em;
  color: var(--ink);
  font-feature-settings: "tnum" 1;
}
.delta {
  font-family: var(--display);
  font-size: 19px;
  font-style: italic;
  color: var(--ink-dim);
  margin-top: 6px;
}
.delta b { font-weight: 700; color: var(--noir); font-style: normal; font-feature-settings: "tnum" 1; }
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px dashed var(--rule);
}
.stat-lbl {
  font-family: var(--mono);
  font-size: 9px;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: var(--ink-faint);
}
.stat-val {
  font-family: var(--display);
  font-size: 22px;
  font-weight: 700;
  color: var(--ink);
  margin-top: 4px;
  font-feature-settings: "tnum" 1;
}
</style>
<div class="label">Current value</div>
<div class="value">${formatINR(current)}</div>
<div class="delta">Spent <b>${formatINR(purchase)}</b> · depreciated <b>${dep}%</b> · ${count} pieces</div>
<div class="grid">
  <div>
    <div class="stat-lbl">avg cost / wear</div>
    <div class="stat-val">${formatINR(avgCpw)}</div>
  </div>
  <div>
    <div class="stat-lbl">avg age</div>
    <div class="stat-val">${Math.round(avgAge)} days</div>
  </div>
</div>
`;
  }
}

customElements.define('almari-value-spotlight', AlmariValueSpotlight);
